// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { AlertCircle as RawAlertCircle } from "lucide-react";
export const AlertCircle = /* @__PURE__ */ createIcon(RawAlertCircle, "AlertCircle", 2);
